// localStorage-backed recent searches (max 5).

import { RecentSearch } from "./types";

const KEY = "jvvnl_recent_searches_v1";
const MAX = 5;

export function getRecentSearches(): RecentSearch[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function addRecentSearch(query: string): RecentSearch[] {
  const q = query.trim();
  if (!q) return getRecentSearches();
  const existing = getRecentSearches().filter(
    (r) => r.query.toLowerCase() !== q.toLowerCase(),
  );
  const next = [{ query: q, ts: Date.now() }, ...existing].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
}

export function removeRecentSearch(query: string): RecentSearch[] {
  const q = query.toLowerCase();
  const next = getRecentSearches().filter((r) => r.query.toLowerCase() !== q);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
}
